<!--
/*******************************************************************************
*@ 컴포넌트명   : MyAccountsWdrwTab.vue
*@ 컴포넌트설명 : 전계좌조회 - 입출금 
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <template v-if="wdrwAcn">
      <account-box-header v-show="openDetail" :summary="brifWdrwAcn" />
      <account-box :acn-list="wdrwAcn" :page="`myAccount`" />
    </template>
    <template v-else-if="!loading">
      <!-- 조회결과가 없음 -->
      <div class="empty">
        <div class="empty-img">
          <i class="icon icon-opt-no" />
        </div>
        <strong class="empty-text">{{ /*조회 내역이 없습니다.*/ $t("MCOM-0000015") }}</strong>
      </div>
    </template>
  </article>
</template>

<script>
import { mapGetters } from "vuex";
import AccountBoxHeader from "@/components/page/accounts/AccountBoxHeader";
import AccountBox from "@/components/page/accounts/AccountBox";
import Common from "@/components/basic/Common";
export default {
  name: "MyAccountsWdrwTab",
  extends: Common,
  props: {
    openDetail: {
      type: Boolean,
      required: true,
    },
    showDetail: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    AccountBoxHeader,
    AccountBox,
  },
  mounted() {
    if (this.brifWdrwAcn) {
      this.showDetailData = true;
    } else {
      this.showDetailData = false;
    }
  },
  computed: {
    ...mapGetters("accounts/myAccounts", ["getWdrwAccountBox"]),
    brifWdrwAcn() {
      if (this.getWdrwAccountBox) {
        return this.getWdrwAccountBox.summary;
      } else {
        return [];
      }
    },
    wdrwAcn() {
      if (this.getWdrwAccountBox) {
        return this.getWdrwAccountBox.data;
      } else {
        return [];
      }
    },
    showDetailData: {
      get() {
        return this.showDetail;
      },
      set(value) {
        this.$emit("update:showDetail", value);
      },
    },
  },
  methods: {},
};
</script>